/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_identity_pool_id:
    "us-east-1:166db6c6-c336-48ff-a69b-77db8032e658",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_FbM7ke6dD",
  aws_user_pools_web_client_id: "7d7t20t2t2560pmjb08h585h9e",
  oauth: {},
  aws_cognito_username_attributes: ["PHONE_NUMBER"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["PHONE_NUMBER"],
  aws_cognito_mfa_configuration: "ON",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: "6",
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["PHONE_NUMBER"],
  aws_appsync_graphqlEndpoint:
    "https://in3y5lgc5vg4pomrf4mzo7wwyq.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "da2-enp74xzttfdcdd34rpolmkz23e",
  aws_cloud_logic_custom: [
    {
      name: "RestApi",
      endpoint: "https://qzb9svf9o7.execute-api.us-east-1.amazonaws.com/prod",
      region: "us-east-1",
    },
  ],
  aws_user_files_s3_bucket: "tawkit-user-uploaded-assets123517-prod",
  aws_user_files_s3_bucket_region: "us-east-1",
};

export default awsmobile;
